import { performRequest } from './api-handler';
import { URLS } from '../utility/urls'

export default () => {
    const { 
        GET_SERVER_DATE } = URLS;
    return {
        getServerDate: (body={}, method='get') =>
         performRequest( method ? method:'get', GET_SERVER_DATE, body, "agent" ),

    }
}